import { render, staticRenderFns } from "./AuthenticationInWrapper.vue?vue&type=template&id=0effc9c9"
import script from "./AuthenticationInWrapper.vue?vue&type=script&lang=ts"
export * from "./AuthenticationInWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports